import { ThemeType } from '@gravity-ui/uikit';
import { THEME_STORAGE_NAME } from './saveUserTheme';

export const WIDGET_THEME_QUERY_PARAM = '_theme';

export const checkThemeIsValid = (theme: string | null): theme is ThemeType => {
    return theme === 'light' || theme === 'dark';
};

const getSystemTheme = () =>
    window.matchMedia('(prefers-color-scheme: dark)')?.matches ? 'dark' : 'light';

export const getThemeFromQuery = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const theme = searchParams.get(WIDGET_THEME_QUERY_PARAM);
    return checkThemeIsValid(theme) ? theme : null;
};

export const getUserTheme = () => {
    const themeParam = getThemeFromQuery();

    if (themeParam) {
        return themeParam;
    }

    const savedTheme = localStorage.getItem(THEME_STORAGE_NAME);
    const isSavedThemeValid = checkThemeIsValid(savedTheme);

    if (isSavedThemeValid) {
        return savedTheme;
    }

    const systemTheme = getSystemTheme();
    const isSystemThemeValid = checkThemeIsValid(systemTheme);

    return isSystemThemeValid ? systemTheme : 'light';
};
